import OnboardingOverview from './onboarding/Overview';
import TrialOverview from './trial/Overview';
import SubscriptionOverview from './subscription/Overview';
import type { FacilityMetricsResult } from '../../services/api/facilityMetricsService';
import type { FacilityPageViewer } from './utils/facilityPageTypes';
import type { Facility, FacilityStatus } from './utils/utils';
import type { PeriodState } from './subscription/periodUtils';

interface FacilityOverviewSectionProps {
    facility: Facility;
    metrics: FacilityMetricsResult | null;
    status: FacilityStatus;
    viewer: FacilityPageViewer;
    selectedPeriod: PeriodState;
    onPeriodChange: (period: PeriodState) => void;
}

export default function FacilityOverviewSection({
    facility,
    metrics,
    status,
    viewer,
    selectedPeriod,
    onPeriodChange,
}: FacilityOverviewSectionProps) {
    if (!metrics) return null;

    if (status === 'not-started') {
        return (
            <OnboardingOverview
                facility={facility}
                metrics={metrics}
                showNextAction={viewer !== 'niAdmin'}
            />
        );
    }

    switch (metrics.stage) {
        case 'onboarding':
            return (
                <OnboardingOverview
                    facility={facility}
                    metrics={metrics}
                    showNextAction={viewer !== 'niAdmin'}
                />
            );
        case 'active':
            return (
                <SubscriptionOverview
                    metrics={metrics}
                    selectedPeriod={selectedPeriod}
                    onPeriodChange={onPeriodChange}
                />
            );
        case 'trial':
        default:
            return <TrialOverview facility={facility} metrics={metrics} />;
    }
}
